import { Card, CardContent, Typography } from "@material-ui/core";
import React from "react";
import useStyles from "../styles";

interface EmptyProps {
  message: string;
}
export const Empty = ({ message }: EmptyProps) => {
  const styles = useStyles();
  return (
    <Card variant="outlined" className={styles.usersNotFoundCard}>
      <CardContent>
        <Typography>{message}</Typography>
      </CardContent>
    </Card>
  );
};
